"use client";

import { SidebarInset, SidebarProvider } from "@universe/ui/components/sidebar";
import { motion } from "framer-motion";
import { usePathname } from "next/navigation";

import { AppSidebar } from "@/components/app-sidebar";
import BreadcrumbHeader from "@/components/breadcrumb-header";
import DashboardSkeleton from "@/components/dashboard-skeleton";
import { useCustomerAccount } from "@/providers";

export default function ProtectedSidebarLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  const { isSwitchingAccount, hasDigitalAssets } = useCustomerAccount();

  return (
    <div className="flex 2xl:max-w-[1800px] w-full relative mx-auto">
      <SidebarProvider>
        {hasDigitalAssets && (
          <div
            className="fixed top-0 left-0 right-0 z-[0] hidden lg:block"
            style={{
              height: "var(--s21-banner-height, 0px)",
              backgroundColor:
                "oklch(from var(--brand-secondary) 0.95 calc(c * 0.12) h)",
            }}
          />
        )}
        <AppSidebar />
        <SidebarInset>
          <BreadcrumbHeader />
          {/* overflow-x-clip contains the sticky headers' intentional
              negative-margin bleed (mx-[-28px] / -mx-3) so it can't push the
              document into horizontal scroll. `clip` (not `hidden`) clips the
              x-axis WITHOUT making this a scroll container — so vertical scroll
              and the sticky header positioning are unaffected. */}
          <div className="light flex flex-1 flex-col p-4 lg:px-6 pt-0 overflow-x-clip">
            <div className="flex flex-col items-left justify-center w-full max-w-8xl mx-auto ">
              <motion.div
                key={pathname + isSwitchingAccount}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{
                  duration: 0.3,
                }}
                className="flex-1"
              >
                {isSwitchingAccount ? <DashboardSkeleton /> : children}
              </motion.div>
            </div>
          </div>
        </SidebarInset>
      </SidebarProvider>
    </div>
  );
}
